import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Redirection logic removed. 
// The app now operates exclusively on https://rasachat.netlify.app/

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);